import APICaller from '../library/APICaller'

const FileServices = {
  /**
   * 파일 리스트
   * @param  {Number} params.pageNo
   * @param  {String} params.searchFileName
   * @param  {Number} params.size
   * @return {Promise}
   */
  getFiles ({ pageNo, searchFileName, size }) {
    return APICaller.get('/api/v1/files', {
      pageNo, searchFileName, size
    })
  },
  /**
   * 파일 업로드
   * @param  {FormData} formData FormData
   * @param  {Function} onUploadProcess 업로드 상태 callback
   * @return {Promise}
   */
  postFiles (formData, onUploadProcess) {
    return APICaller.postUpload('/api/v1/files', formData, onUploadProcess)
  },
  /**
   * 파일 다운로드 -- 확인 필요 다운로드 같은경우는 API로 진행하지 않음
   * @param  {String} fileId
   * @return {Promise}
   */
  getFilesWithFileId (fileId) {
    return APICaller.get(`/api/v1/files/${fileId}`)
  },
  /**
   * 파일 수정
   * @param  {String} fileId 파일 아이디
   * @param  {FormData} formData FormData
   * @param  {Function} onUploadProcess 업로드 상태 callback
   * @return {Promise}
   */
  putFilesWithFileId (fileId, formData, onUploadProcess) {
    return APICaller.putUpload(`/api/v1/files/${fileId}`, formData, onUploadProcess)
  },
  /**
   * 파일 삭제
   * @param  {String} fileId
   * @return {Promise}
   */
  deleteFileWithFileId (fileId) {
    return APICaller.delete(`/api/v1/files/${fileId}`)
  },
  getCSVFile(payLoad){
    return APICaller.download(payLoad.url, payLoad.fileName).then(r => console.log(r))
  }
}

export default FileServices



// WEBPACK FOOTER //
// ./src/services/FileServices.js